import PopupTitleDangerous from "./PopupTitleDangerous";
export default PopupTitleDangerous;